export enum ManagementLayerTabUK {
  SUMMARY = "summary",
  FILES = "files",
  REPORTS = "reports",
  LETTERS = "letters",
  ACTIVITY = "activity",
  FUNDING = "funding",
}

export enum ManagementLayerTabUS {
  SUMMARY = "summary",
  FILES = "files",
  REPORTS = "reports",
  LETTERS = "letters",
  ACTIVITY = "activity",
}

export enum ManagementFilesLayerTabUK {
  UPLOADED = "uploaded",
  PURCHASED = "purchased",
}

export enum ManagementFilesLayerTabUS {
  UPLOADED = "uploaded",
  PURCHASED = "purchased",
}

export enum ManagementReportsType {
  LT = "lt",
  LANDFUND_APPRAISAL = "landfund_appraisal",
  RENKAP = "renkap",
  ATKINS = "atkins",
  AIDASH = "aidash",
}
